<div class="grid">
    <div class="
        col-4
        sm:col-4
        md:col-4
        lg:col-4
        xl:col-4
        flex
        align-items-center
        justify-content-center
        "
        >
        <p-button (onClick)="event('-')" label="-" styleClass=""  [disabled]="disabled"></p-button>
    </div>
    <div class="
        col-4
        sm:col-4
        md:col-4
        lg:col-4
        xl:col-4">
        <div style="border: solid 1px #8C8C8C; border-radius: 5px; display: flex; justify-content: center; align-items: center; height: 35px;">
            {{ ngValue }}
        </div>
    </div>
    <div class="
        col-4
        sm:col-4
        md:col-4
        lg:col-4
        xl:col-4
        flex
        align-items-center
        justify-content-center
        "
        >
        <p-button (onClick)="event('+')" label="+" styleClass="" [disabled]="disabled"></p-button>
    </div>
</div>

